/**
 * @fileoverview Main entry point for the React application. Renders the root `App` component wrapped in `StatsigProvider` into the DOM using `ReactDOM.createRoot`. Initializes Sentry for error tracking.
 */

import React from 'react'
import * as Sentry from '@sentry/react'

import ReactDOM from 'react-dom/client'
import App from './App'
import './styles/core.css'
import 'lite-youtube-embed/src/lite-yt-embed.css'
import 'lite-youtube-embed/src/lite-yt-embed.js'
import { StatsigProvider } from './components/StatsigProvider'
import { isProd } from './utils/env'

const sentryDsn = import.meta.env.VITE_SENTRY_DSN
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    sendDefaultPii: true,
    environment: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  })
} else if (!isProd()) {
  console.log('no sentryDsn')
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <StatsigProvider>
      <App />
    </StatsigProvider>
  </React.StrictMode>,
)
